import {
  CLOSE_CUSTOMER_REPORT_REQUEST,
  CLOSE_CUSTOMER_REPORT_RESPONSE,
  CLOSE_CUSTOMER_REPORT_ERROR,
  CREATE_CUSTOMER_REPORT_REQUEST,
  CREATE_CUSTOMER_REPORT_RESPONSE,
  CREATE_CUSTOMER_REPORT_ERROR,
  GET_CUSTOMER_REPORT_REQUEST,
  GET_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_ERROR,
  GET_CUSTOMER_REPORT_ACTION_REQUEST,
  GET_CUSTOMER_REPORT_ACTION_RESPONSE,
  GET_CUSTOMER_REPORT_ACTION_ERROR,
  SET_CURRENT_STAGE,
  SET_CURRENT_STAGE_ATTRIBUTES,
} from 'actions/grace';

import currentStageReducer from './currentStage';
import nextStageReducer from './nextStage';
import nextStageOptionsReducer from './nextStageOptions';

const initialState = {
  report: null,
  basketsWithMeals: [],
  chatHandoffId: null,
  currentStage: null,
  nextStage: null,
  nextStageOptions: [],
  resolutionInfo: null,
  resolutionCredit: null,
  resolutionRefund: null,
  resolutionTotal: null,
  isAdaResolution: false,
  isCsResolution: false,
  ingredients: [],
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_CUSTOMER_REPORT_RESPONSE:
      return initialState;
    case CLOSE_CUSTOMER_REPORT_REQUEST:
    case CREATE_CUSTOMER_REPORT_REQUEST:
    case GET_CUSTOMER_REPORT_REQUEST:
      return {
        ...state,
        error: null,
      };
    case CREATE_CUSTOMER_REPORT_RESPONSE:
    case GET_CUSTOMER_REPORT_RESPONSE:
      if (action.response.customerReport === undefined) {
        return { ...state };
      } else {
        return {
          ...state,
          report: action.response.customerReport,
          ...nextStageReducer(state.nextStage, action),
          ...nextStageOptionsReducer(state.nextStageOptions, action),
          ...currentStageReducer(state.currentStage, action),
          basketsWithMeals: action.response?.resolver?.basketsWithMeals,
          ingredients: action.response?.resolver?.ingredients,
          error: null,
        };
      }
    case CLOSE_CUSTOMER_REPORT_ERROR:
    case CREATE_CUSTOMER_REPORT_ERROR:
    case GET_CUSTOMER_REPORT_ERROR:
      return {
        ...state,
        error: action.error || action.response?.error,
      };
    case GET_CUSTOMER_REPORT_ACTION_REQUEST:
      return {
        ...state,
        error: null,
      };
    case GET_CUSTOMER_REPORT_ACTION_RESPONSE:
      return {
        ...state,
        ingredients: action.response.resolver.ingredients,
        basketsWithMeals: action.response.resolver.basketsWithMeals,
        chatHandoffId: action.response.resolver.chatHandoffId,
        ...nextStageReducer(state.nextStage, action),
        ...nextStageOptionsReducer(state.nextStageOptions, action),
        ...currentStageReducer(state.currentStage, action),
        resolutionInfo: action.response.resolver.resolutionInfo,
        resolutionCredit: action.response.resolver.resolutionCredit,
        resolutionRefund: action.response.resolver.resolutionRefund,
        resolutionTotal: action.response.resolver.resolutionTotal,
        isAdaResolution: action.response.resolver.isAdaResolution,
        isCsResolution: action.response.resolver.isCsResolution,
        error: null,
      };
    case GET_CUSTOMER_REPORT_ACTION_ERROR:
      return {
        ...state,
        error: action.response.error,
      };
    case SET_CURRENT_STAGE:
      return {
        ...state,
        ...currentStageReducer(state.currentStage, action),
      };
    case SET_CURRENT_STAGE_ATTRIBUTES:
      return {
        ...state,
        ...currentStageReducer(state.currentStage, action),
      };
    default:
      return state;
  }
};

export const selectCustomerReport = state => state.grace.customerReport.report;
export const selectIngredientOptions = state => state.grace.customerReport.ingredients;
export const selectCurrentStage = state => state.grace.customerReport.currentStage;
export const selectNextStage = state => state.grace.customerReport.nextStage;
export const selectNextStageOptions = state => state.grace.customerReport.nextStageOptions;
export const selectBasketsWithMeals = state => state.grace.customerReport.basketsWithMeals;
export const selectResolution = state => ({
  resolutionInfo: selectResolutionInfo(state),
  resolutionCredit: selectResolutionInfo(state)?.resolutionCredit,
  resolutionRefund: selectResolutionInfo(state)?.resolutionRefund,
  resolutionTotal: selectResolutionInfo(state)?.resolutionTotal,
});
export const selectResolutionInfo = state => state.grace.customerReport.resolutionInfo;
export const selectIsAdaResolution = state => state.grace.customerReport.isAdaResolution;
export const selectIsCsResolution = state => state.grace.customerReport.isCsResolution;
export const selectRecipeCardLink = state =>
  state.grace.customerReport.resolutionInfo?.recipeCardLink;
